import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=0bf3e7bc&"
import script from "../../models/analysis/app-download.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/app-download.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports